export const LICENSED = 'LICENSED'
export const PUBLIC = 'PUBLIC'
export const PACKAGE = 'PACKAGE'
export const TEST = 'TEST'
